import type { ReactNode } from "react";
import type { AppUser } from "../../types";
import { Flex } from "../flex";
import { HeaderUserDetails } from "../header-user-details/HeaderUserDetails";
import styles from "./AppHeader.module.scss";

export const AppHeader = ({
  left,
  right,
  user,
  onSettings,
  onLogout,
}: {
  left?: ReactNode;
  right?: ReactNode;
  user: AppUser | null;
  onSettings?: () => void;
  onLogout: () => void | Promise<void>;
}) => {
  return (
    <Flex align="center" justify="space-between" className={styles["comp"]}>
      <div className={styles["comp__left"]}>{left}</div>
      <Flex gap={16} align="center">
        {user ? (
          <HeaderUserDetails
            user={user}
            onSettings={onSettings}
            onLogout={onLogout}
          />
        ) : null}
        {right}
      </Flex>
    </Flex>
  );
};
